<template>
  <div :class="$style.winning">
    <div :class="$style.mask" @touchmove.prevent></div>
    <div :class="$style.context">
      <div :class="$style.window">
        <h1>中奖记录</h1>
        <Loading
          :class="$style.loading"
          :size="'40px'"
          :vertical="true"
          v-show="loading"
          >加载中...</Loading
        >
        <ul :class="$style.col" v-show="!loading">
          <li>
            <span>时间</span>
            <span>奖品</span>
            <span>备注</span>
          </li>
          <li v-for="(item, index) in list" :key="index">
            <span>{{ item.created_at }}</span>
            <span>{{ item.gift_name }}</span>
            <span v-if="item.type === 1">{{
              `礼包码为：${item.lottery_code}`
            }}</span>
            <span v-if="item.type === 2">
              <a @click="$emit('openDownloadLink')">请点击前往游戏领取</a>
            </span>
            <span
              v-if="item.type === 3 && item.address && item.address.real_name"
            >
              <p>{{ `姓名：${item.address.real_name}` }}</p>
              <p>{{ `联系方式：${item.address.mobile}` }}</p>
              <p>{{ `具体地址：${item.address.address_str}` }}</p>
            </span>
            <span
              v-if="item.type === 3 && item.address && !item.address.real_name"
            >
              <a @click="showAddress(item)">请点击填写地址</a>
            </span>
          </li>
        </ul>
      </div>
      <i class="iconfont yw-close" @click="$emit('close')"></i>
    </div>
  </div>
</template>

<script>
import { lotteryRecord } from "@/apis/recall";
import { mapActions, mapState } from "vuex";
import { Loading } from "vant";

export default {
  name: "",
  props: {
    activityId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  mounted() {
    this.getRecord();
  },
  computed: {
    ...mapState({
      template_id: (state) => state.recall.template_id,
    }),
  },
  methods: {
    ...mapActions({
      showCustomer: "recall/showCustomer",
    }),
    showAddress(item) {
      const obj = {
        gift_type: 3,
        gift_name: item.gift_name,
        record_id: item.record_id,
        activityId: this.activityId,
      };
      this.$emit("showDialog", obj);
    },
    async getRecord() {
      this.loading = true;
      const r = await lotteryRecord(this.template_id);
      this.list = r.content.lotteries;
      this.loading = false;
    },
  },
  components: { Loading },
};
</script>

<style lang="scss" module>
.lighter {
  color: #3cc0ff;
}
@mixin border-bottom-1px($left: 0, $width: 100%) {
  position: relative;
  &:before {
    display: block;
    position: absolute;
    left: $left;
    bottom: 1px;
    width: $width;
    border-top: 1px solid #ececec;
    content: " ";
    z-index: 1;
  }
}

.winning {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.65);
  }
  .context {
    position: absolute;
    width: 351px;
    height: 365px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: #9f9f9f;
    .window {
      width: 351px;
      height: 305px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 10px 15px;
      .loading {
        margin-top: 100px;
      }
      > h1 {
        color: #000000;
        font-size: 15px;
        margin-bottom: 10px;
        text-align: center;
      }
      .col {
        height: 250px;
        overflow-y: auto;
        border: 0.5px solid #ccc;
        > li {
          width: 100%;
          min-height: 30px;
          // background-color: pink;
          display: flex;
          text-align: center;
          border-bottom: 0.5px solid #ccc;
          line-height: 20px;
          > span {
            display: flex;
            justify-content: center;
            align-items: center;
            word-break: break-all;
          }
          > span:nth-child(1) {
            width: 30%;
            border-right: 0.5px solid #ccc;
          }
          > span:nth-child(2) {
            width: 30%;
            border-right: 0.5px solid #ccc;
          }
          > span:nth-child(3) {
            width: 40%;
            flex-direction: column;
          }
          p {
            width: 100%;
            word-break: break-all;
          }
        }
        > li:nth-child(1) {
          line-height: 30px;
        }
      }
    }
    :global {
      .yw-close {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        color: #ffffff;
        font-size: 50px;
        z-index: 1;
        margin: auto;
        font-weight: 100;
      }
    }
  }
}
</style>